module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-Pillar-Page-Resource.99d4addb.jpg";